module.exports = __webpack_public_path__ + "static/media/logo.52730654.svg";